// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1ehbw","vLegacy":"SelectSecondary_vLegacy__2hHGa","error":"SelectSecondary_error__F46Z4","disabled":"SelectSecondary_disabled__NVcI7"};